module.exports = __webpack_public_path__ + "img/upmood_band_real_small1.3f1934bd.png";